module.exports = __webpack_public_path__ + "dist/media/logo--mt.1a44266a.svg";